<template>
    <div class="text-info-500">
        <p
            v-for="(item, index) in data"
            :key="index"
            class="leading-[41px]">
            {{ item.code }}
            <br >
        </p>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref()

onBeforeMount(() => {
  data.value = params?.value?.data.journeys || {}
})

const nextJourneyRoute = (item: any) => {
  if (!item) {
    return null
  }
  return {
    name: 'c-id-journey-management',
    query: { journeyId: item?._id, action: 'view' }
  }
}
</script>
